import React from "react";
import "./loading.css";

const LoadingDots = () => {
  return (
    <div className="loading-dots">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default LoadingDots;
